<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Code of Conduct</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="javascript:void(0);">Code of Conduct</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="calender ptb--100  horizontal--tab">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Code of Conduct for Faculty</h4>
            <a href="https://drive.google.com/file/d/1zOJ-OgONO9Ib8C23CLem-c12CdV7iXXA/view?usp=sharing"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Code of Conduct for Student</h4>
            <a href="https://drive.google.com/file/d/1PJ9JmK3AGDIoZ9uEfR0m3pand3Ee3Wb9/view?usp=sharing"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Code of Conduct for Principal</h4>
            <a href="https://drive.google.com/file/d/19OCZ3sbfcZzyqHXHm64-rfcyUw0-usgv/view?usp=sharing"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Code of Conduct for Governing Body</h4>
            <a href="https://drive.google.com/file/d/1L2P8VfLLDb5ZYrkPX4ytvzknHxrAP331/view?usp=sharing"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
